import React from 'react';
import ListInstances from '../components/TemplateInstances/ListInstances';
import AuthenticatedLayout from '../components/AuthenticatedLayout';

export default function ListBotIntances() {
    return (
        <AuthenticatedLayout title="Instancias (Servidores)">
            <ListInstances />
        </AuthenticatedLayout>
    );
}
